import { AnimationBaseController, IAnimationControllerConfiguration, Inject, SoundType } from "@denishussar/html5-game-engine";
import { Rectangle } from "pixi.js";
import { AnimationContents } from "../../../AnimationContents";
import { Backend } from "../../Backend";
import { ButtonController, IButtonControllerOptions } from "../../Common/ButtonController";
import { getLevelConfig } from "../../Common/GameConfig";
import { GarageEvents } from "../../Constants/Events";
import { Sounds } from "../../Constants/Sounds";
import { LocalizationContents } from "../../LocalizationContents";
import { GameLogic } from "../../Logic/GameLogic";
import { GarageLogic } from "../../Logic/GarageLogic";
import { AppStateEnum, GameModel } from "../../Models/GameModel";
import { SoundModel } from "../../Models/SoundModel";
import { thousandSpacing } from "../../Utils/StringRework";

export interface ILevelSelectorOptions {
    level: number;
}

export class LevelSelectorController extends AnimationBaseController {
    $model: GameModel;

    constructor(
        @Inject private options: ILevelSelectorOptions,
        @Inject private logic: GameLogic,
        @Inject private garageLogic: GarageLogic,
        @Inject private backend: Backend,
    ) {
        super("LevelSelectionScreen");
    }

    getConfiguration(): IAnimationControllerConfiguration {
        const events = {};
        events[GarageEvents.buyLevel] = (index) => {
            if ((index+1) == this.options.level) {
                this.soundManager.playSound(Sounds.PURCHASE, 0, SoundModel.UI);
                this.gotoAndStopByQuery("buttons_route_selection", 0);
                
            }
        }
        return {
            sounds: [
                {
                    id: Sounds.PURCHASE,
                    type: SoundType.SFX,
                },
                {
                    id: Sounds.BUTTON,
                    type: SoundType.SFX,
                },
            ],
            childControllers: {
                startButton: {
                    instanceName: "buttons_route_selection.btn_start_route_selection",
                    controller: ButtonController,
                    options: <IButtonControllerOptions>{
                        // onClick: () => { this.$model.currentLevel = this.options.level; this.logic.setState(AppStateEnum.game); },

                    }
                },
                buyButton: {
                    instanceName: "buttons_route_selection.btn_buy_route_selection",
                    controller: ButtonController,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            // this.garageLogic.buyLevel(this.options.level - 1);
                        },
                    }
                }
            },
            onPointerDown: () => {
                this.soundManager.playSound(Sounds.BUTTON, 0, SoundModel.UI);
                const { unlockedLevels } = this.backend.getState();
                if (!unlockedLevels[this.options.level - 1]) {
                    this.garageLogic.buyLevel(this.options.level - 1);
                }
                else {
                    this.$model.currentLevel = this.options.level;
                    this.logic.setState(AppStateEnum.game);
                }
            },
            modelEvents: events,
        }
    }

    onInitialize() {
        this.gotoAndStopByQuery("selection_route", this.options.level - 1);
        this.display.hitArea = new Rectangle(-790 / 2, -790 / 2, 790, 790);
        
        const { unlockedLevels } = this.backend.getState();
        if (!unlockedLevels[this.options.level - 1]) {
            this.gotoAndStopByQuery("buttons_route_selection", 1);
            this.setTextByQuery("buttons_route_selection.btn_buy_route_selection.price_txt", " " + thousandSpacing(getLevelConfig(this.options.level-1, "price")));
            this.setTextVerticalAlignByQuery("buttons_route_selection.btn_buy_route_selection.price_txt", "middle")
        }
        this.localise();
    }

    private localise() {
        this.setTextByQuery("buttons_route_selection.btn_start_route_selection.button_track_ready", LocalizationContents.getText("button_track_ready"));
        this.setTextByQuery("selection_route.title", LocalizationContents.getText("title_track_" + this.options.level))
    }
}